export const handleListFormat = (editor: any, value: string) => {
  const el: HTMLElement | null = editor.selection.element();
  if (!el) return;
  if ((value === 'bullet' || value === 'checkmark') && !el.closest('ul')) {
    editor.lists.format('UL');
  }
  if (value === 'number') {
    editor.lists.format('OL');
  }
  if (value === 'none') {
    if (el.closest('ul')) editor.lists.format('UL');
    else if (el.closest('ol')) editor.lists.format('OL');
  }
  const selected: HTMLElement | null = editor.selection.blocks()[ 0 ];
  if (!selected) return;
  value === 'checkmark'
    ? selected.closest('ul')?.classList.add('custom-check-mark')
    : selected.closest('ul')?.classList.remove('custom-check-mark');
  value === 'checkmark'
    ? selected.closest('ol')?.classList.add('custom-check-mark')
    : selected.closest('ol')?.classList.remove('custom-check-mark');
};

export const getListType = (el: HTMLElement) => {
  let type: string = 'none';
  if (el.closest('ol')) {
    type = 'number';
  } else if (el.closest('ul')) {
    type = !!el.closest('.custom-check-mark') ? 'checkmark' : 'bullet';
  }
  return type;
};

export const isFroalaInComposedPath = (path: EventTarget[]): boolean => {
  return (
    path.find((el) => {
      if (typeof (el as HTMLElement).className === 'string') {
        return (el as HTMLElement).className.includes('froala-editor');
      }
      return false;
    }) != null
  );
};

export const checkElementExists = (node: Node | undefined | null, selector: string): boolean => {
  // console.log("ADASD", node)
  if (!node) return false;
  if (node.nodeName === selector.toUpperCase()) return true;

  let el: HTMLElement | null;
  const deepestChild = getDeepestChildNode(node)
  if (deepestChild instanceof HTMLElement) el = deepestChild;
  else el = deepestChild.parentElement

  if (!el) return false;

  return !!el.closest(selector)
}

export const getDeepestChildNode = (node: Node): Node => {
  if (!(node instanceof HTMLElement)) return node;
  if (node.children.length === 0) return node;

  const lastChild = node.children[ node.children.length - 1 ];
  return getDeepestChildNode(lastChild);
}

export const unwrapElement = (el: Element) => {
  if (el && el.parentNode) {
    while (el.firstChild) {
      el.parentNode.insertBefore(el.firstChild, el);
    }
    el.remove();
  }
}
